import { doc, getDoc, increment, serverTimestamp, runTransaction } from 'firebase/firestore';
import { db } from '../config/firebase';

export const checkCustomerAgent = async (mobile, agentId) => {
  try {
    // Remove all non-numeric characters from mobile number when used as document ID
    const mobileId = mobile.replace(/\D/g, '');
    const customerRef = doc(db, 'customer_agent_map', mobileId);
    const customerDoc = await getDoc(customerRef);
    
    if (customerDoc.exists()) {
      const customerData = customerDoc.data();
      if (customerData.agentId !== agentId) {
        // Handle both Firestore Timestamp and Date objects
        const firstSeen = customerData.firstSeen?.toDate ? 
          customerData.firstSeen.toDate() : 
          customerData.firstSeen;
          
        return {
          available: false,
          existingAgentId: customerData.agentId,
          firstSeen: firstSeen
        };
      }
    }
    
    return { available: true };
  } catch (error) {
    console.error('Error checking customer agent:', error);
    throw new Error('Failed to verify customer information');
  }
};

export const updateCustomerAgent = async (mobile, agentId, bookingId) => {
  // Remove all non-numeric characters from mobile number when used as document ID
  const mobileId = mobile.replace(/\D/g, '');
  const customerRef = doc(db, 'customer_agent_map', mobileId);
  const now = serverTimestamp();
  
  try {
    await runTransaction(db, async (transaction) => {
      const customerDoc = await transaction.get(customerRef);
      
      if (customerDoc.exists()) {
        if (customerDoc.data().agentId !== agentId) {
          throw new Error(`CUSTOMER_CLAIMED:${customerDoc.data().agentId}`);
        }
        
        // Update existing customer
        transaction.update(customerRef, {
          lastBookingId: bookingId,
          bookingCount: increment(1),
          lastSeen: now,
          updatedAt: now
        });
      } else {
        // Create new customer
        transaction.set(customerRef, {
          agentId,
          firstBookingId: bookingId,
          lastBookingId: bookingId,
          bookingCount: 1,
          firstSeen: now,
          lastSeen: now,
          createdAt: now,
          updatedAt: now
        });
      }
    });
    
    return { success: true };
  } catch (error) {
    console.error('Error updating customer agent:', error);
    
    if (error.message.startsWith('CUSTOMER_CLAIMED:')) {
      throw error;
    }
    
    throw new Error(`Failed to update customer information: ${error.message}`);
  }
};
